module.exports = __webpack_public_path__ + "img/map.e6f9d61b.png";